<template>
    <d2-container>
        <div id="shareDiv" class="divWH">
            <img class="imageWH" style="object-fit: cover;object-position:center bottom;"
                :src="`https://wjtr-mall.oss-cn-beijing.aliyuncs.com/ttmy/${image}.png?${new Date().getTime()}`"
                crossOrigin="anonymous" />
            <div class="bottomText">
                <!-- <div class="textTip textTip1">
                    <div>我是第{{ isReady ? id : pid }}位代言人</div>
                    <div class="textTipBottom">我倡议<span>{{ ruonerText }}</span></div>
                </div> -->
                <div class="textTip">
                    <div>我是第{{ isReady ? id : pid }}位代言人</div>
                    <div class="textTipBottom">我倡议<span>{{ ruonerText }}</span></div>
                </div>
                <template v-if="!shoting">
                    <div v-if="isReady" class="buttonBox1" @click="generateImage">
                        <div class="buttonBox">
                            <div>
                                生成海报，长按保存
                            </div>
                            <div class="btnTip">
                                让更多人看到，共传文明祭祀。
                            </div>
                        </div>
                    </div>
                    <div v-else class="buttonBox1" @click="onDialog">
                        <div class="buttonBox">
                            <div>
                                我支持我传递
                            </div>
                            <div class="btnTip">
                                已有{{ countNum }}人传递，快来加入吧！
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="qrcodeDiv">
                <!-- <div id="qrcode" style="width: 100%;height:100%"></div> -->
                <img v-if="rQcode" :src="('data:image/png;base64,') + rQcode" alt="" style="width: 100%;">
            </div>
        </div>
        <template v-if="isReady&&!shoting">
            <img v-if="image != 'image1'" class="btnImage leftImage" src="./image/leftImage.png"
                @click="leftImageFun" />
            <img v-if="image != 'image11'" class="btnImage rigthImage" src="./image/rigthImage.png"
                @click="rigthImageFun" />
        </template>
        <div class="dialog-mask" v-if="dialogVisable" @click.stop="dialogVisable = false" @touchmove.stop.prevent>
            <div class="dialog" @click="onConfirm">
                <div class="title">我支持我传递</div>
                <div class="desc">即将生成您的专属海报，生成后请转发到朋友圈。</div>
                <div class="button">去选择模板</div>
            </div>
        </div>
        <div class="dialog-mask" style="background-color: rgba(0, 0, 0, 0.7)" v-if="preview"
            @click.stop="preview = false" @touchmove.stop.prevent>
            <img :src="imageUrl" alt="" class="img-pre" @click.stop @touchmove.stop.prevent>
        </div>
    </d2-container>
</template>
<script>
import mathUtil from '../../utils/mathUtil'
import jquery from '../../utils/jquery.min'
import jqrcode from '../../utils/jquery.qrcode'
import { mapActions } from 'vuex'
import html2canvas from 'html2canvas'
import qs from 'qs'
import wxshare from '@/utils/share'
import wx from 'weixin-js-sdk'

export default {
    title: '海报',
    index: 15,
    data() {
        return {
            image: 'image2',
            countNum: 0,
            weChatUrl: 'https://wx.app2024.dqttmy.net/common/poster',
            openId: '',
            ruonerText: '“传承文明祭祀，共建绿色家园”',
            imageUrl: '',
            ruoner: {
                image1: '“传承文明祭祀，共建绿色家园”',
                image2: '云端寄哀思，文明传真情',
                image3: '鲜花换纸钱，文明寄思念',
                image4: '绿色清明 低碳追思',
                image5: '清明祭先祖，文明伴新风',
                image6: '清明寄思语，文明润人心',
                image7: '摒弃烟火气，传承感恩心',
                image8: '春风传心意，云端寄追思',
                image9: '摒弃旧俗陋习，崇尚文明祭扫',
                image10: '文明祭扫践于行，生态清明始于心',
                image11: '文明新风拂清明，生态家园共守护'
            },
            id: '',
            pid: '',
            sharePath: '',
            isReady: false,
            dialogVisable: false,
            urlData: '',
            rQcode: '',
            preview: false,
            shoting: false
        }
    },
    methods: {
        ...mapActions('d2admin/poster', [
            'posterSharingSharing',
            'queryPoster',
            'genTicket',
            'uploadBase64'
        ]),
        leftImageFun() {
            let images = this.image.split('image')
            let numberS = mathUtil.accSub(images[1], 1)
            this.image = 'image' + numberS
            this.ruonerText = this.ruoner[this.image]
        },
        rigthImageFun() {
            let images = this.image.split('image')
            let numberS = mathUtil.accAdd(images[1], 1)
            this.image = 'image' + numberS
            this.ruonerText = this.ruoner[this.image]
        },
        onQueryPoster() {
            this.queryPoster({
                openId: this.openId,
                poster: this.image,
                pid: this.pid
            }).then(async res => {
                if (res.result === '1') {
                    this.id = res.data.id
                    this.countNum = res.data.countNum
                    this.image = res.data.poster
                    this.rQcode = res.data.rQcode
                    this.generatePath()
                    // await this.generateCode()
                    this.shareToWechat()
                } else {
                    this.$alert(res.message, '操作提示', {
                        confirmButtonText: '确定'
                    })
                }
            })
        },
        async generateImage() {
            this.loading = this.$loading({
                fullscreen: true,
                text: '生成海报中...',
                background: 'rgba(0, 0, 0, 0.6)'
            })
            this.shoting = true
            const res = await this.posterSharingSharing({
                openId: this.openId,
                poster: this.image,
                pid: this.pid
            }).catch(() => {})
            if (res && res.result === '1') {
                this.id = res.data.id
                this.countNum = res.data.countNum
                this.rQcode = res.data.rQcode
                this.generatePath()
                // await this.generateCode()
            } else {
                this.$alert(res.message, '操作提示', {
                    confirmButtonText: '确定'
                })
            }
            const shareDiv = document.getElementById('shareDiv')
            shareDiv.style.width = '100%'
            shareDiv.style.height = '100%'
            try {
                window.scrollTo(0, 0)
                const canvas = await html2canvas(shareDiv, {
                    allowTaint: true,
                    taintTest: true,
                    useCORS: true,
                    scale: 1.5,
                    dpi: window.devicePixelRatio * 1.5,
                    height: shareDiv.scrollHeight, //画布高度（包含未显示的滚动部分）
                    width: shareDiv.scrollWidth, //画布高度（包含未显示的滚动部分）
                    windowWidth: shareDiv.scrollWidth,
                    windowHeight: shareDiv.scrollHeight,
                    scrollY: 0,
                    scrollX: 0
                })
                const dataURL = canvas.toDataURL('image/png')
                this.imageUrl = dataURL
                shareDiv.style.width = '100vw'
                shareDiv.style.height = '100vh'
                this.shareToWechat()
                // this.previewImg()
                this.previewImage()
                this.shoting = false
                this.loading.close()
            } catch (error) {
                console.error('生成 canvas 出错:', error)
                this.$alert('生成海报错误，请稍后重试', '提示', {
                    confirmButtonText: '确定'
                })
                this.loading.close()
                shareDiv.style.width = '100vw'
                shareDiv.style.height = '100vh'
                this.shoting = false
            }
        },
        generatePath() {
            this.sharePath =
                this.weChatUrl +
                '?' +
                qs.stringify({
                    id: this.id,
                    pic: this.image
                })
        },
        generateCode() {
            return new Promise(res => {
                jQuery('#qrcode').html('')
                setTimeout(() => {
                    jQuery('#qrcode').qrcode({
                        text: this.rQcode,
                        width: 59,
                        height: 59,
                        render: 'canvas'
                    })
                    setTimeout(() => {
                        res()
                    }, 100)
                }, 100)
            })
        },
        shareToWechat() {
            wxshare(
                {
                    title: '第九届清明文化节',
                    desc: '我倡导绿色祭祀，文明祭祀',
                    link: this.sharePath
                },
                // location.href.split('#')[0]
                // parent.location.href
                // 'https://wx.app2024.dqttmy.net/common/poster?id=2&pic=image2'
                `https://wx.app2024.dqttmy.net/common/poster?id=${this.pid ||
                    ''}&pic=${this.$route.query.pic || ''}`
            )
        },
        onDialog() {
            this.dialogVisable = true
        },
        onConfirm() {
            this.isReady = true
            this.dialogVisable = true
        },
        previewImage() {
            this.preview = true
        },
        previewImg() {
            // let arr = this.imageUrl.split(',')
            // let mime = arr[0].match(/^data:image\/([^;,]+)/i)[1]
            // let bstr = atob(arr[1])
            // let n = bstr.length
            // let u8arr = new Uint8Array(n)
            // while (n--) {
            //     u8arr[n] = bstr.charCodeAt(n)
            // }
            // const imgs = new File([u8arr], 'poster', { type: mime })
            // const formData = new FormData()
            // formData.append('file', imgs)
            this.uploadBase64(this.imageUrl)
                .then(res => {
                    this.urlData = res
                    this.loading.close()
                    // wx.previewImage({
                    //     current: res,
                    //     urls: [res]
                    // })
                    this.previewImage()
                })
                .catch(e => {
                    this.loading.close()
                    console.log(e)
                })
        }
    },
    mounted() {
        this.image = this.$route.query.pic || 'image2'
        this.pid = this.$route.query.id
        this.openId = this.$route.query.openid
        this.isReady = !this.pid
        this.onQueryPoster()
         wx.ready(function () {
                //分享给朋友
                wx.updateAppMessageShareData({
                    title: '第九届清明文化节',
                    desc: '我倡导绿色祭祀，文明祭祀',
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    }
                })

                //分享到朋友圈
                wx.updateTimelineShareData({
                    title: '第九届清明文化节',
                    desc: '我倡导绿色祭祀，文明祭祀',
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    }
                })

            })
    }
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: 'huangkaihuaLawyerfont';
    src: url('https://wjtr-mall.oss-cn-beijing.aliyuncs.com/ttmy/zitidi.com.ttf');
}

.divWH {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: relative;

    .imageWH {
        width: 100%;
        height: 100%;
        display: block;
    }

    .bottomText {
        position: absolute;
        bottom: 115px;
        z-index: 9;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-content: center;
    }

    .textTip {
        padding: 0px 12px;
        font-family: huangkaihuaLawyerfont;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        text-align: center;
        font-style: normal;
        text-transform: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
        background: url(~@/pages/poster/image/text-bg.png) no-repeat;
        background-size: 100% 100%;
        width: 375px;
        height: 200px;
        -webkit-user-select: none;
        user-select: none;
        margin: 0 auto;

        .textTipBottom {
            margin-top: 12px;

            span {
                font-size: 22px;
            }
        }

        &.textTip1 {
            // padding: 0px 12px;
            font-family: huangkaihuaLawyerfont;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            text-align: center;
            font-style: normal;
            text-transform: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 1);
            width: 100%;
            border-radius: 60px 60px 60px 60px;
            filter: blur(46px);
            position: absolute;
            top: 0px;
            z-index: 0;
            height: 80px;
            padding: unset;
        }
    }

    .buttonBox01 {
        height: 100px;
    }
}

.buttonBox1 {
    margin-top: -35px;
    width: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    -webkit-user-select: none;
    user-select: none;

    .buttonBox {
        padding: 0px 10px;
        min-width: 258px;
        min-height: 60px;
        background-color: rgba(0, 0, 0, 0.8);
        border-radius: 40px 40px 40px 40px;
        border: 1px solid #ffffff;
        box-sizing: border-box;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 1;
        vertical-align: middle;
        white-space: nowrap;
        font-family: huangkaihuaLawyerfont, huangkaihuaLawyerfont;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;

        .btnTip {
            margin-top: 8px;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
        }
    }
}

.btnImage {
    position: absolute;
    top: 43%;
    width: 44px;
    height: 106px;
    z-index: 11;

    &.leftImage {
        left: 19px;
    }

    &.rigthImage {
        right: 19px;
    }
}

.qrcodeDiv {
    width: 59px;
    height: 59px;
    position: absolute;
    bottom: 15px;
    right: 18px;
}

.myCanvas {
    position: absolute;
    top: 0px;
    width: 100vw;
    height: 100vh;
}

.dialog-mask {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    .dialog {
        width: 75vw;
        background-color: #fff;
        transform: translateY(-30px);
        border-radius: 20px;
        background-image: url('~@/pages/poster/image/dialog-bg.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        padding: 16px 20px 17px;
        font-family: huangkaihuaLawyerfont;

        .title {
            font-weight: 400;
            font-size: 18px;
            color: #000000;
            line-height: 32px;
            text-align: center;
        }

        .desc {
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.67);
            line-height: 20px;
            text-align: center;
        }

        .button {
            width: 189px;
            height: 42px;
            background: rgba(0, 0, 0, 0.8);
            border-radius: 40px 40px 40px 40px;
            border: 1px solid #ffffff;
            text-align: center;
            line-height: 42px;
            margin: 15px auto 0;
            color: #fff;
        }
    }

    .img-pre {
        height: 75vh;
        width: auto;
        display: block;
    }
}
</style>
